export const ur_UR_the_prophet = [
  {
    slug: 'front-cover-prophet-urdu',
    name: 'مکھ پٹی - حضرت محمد ﷺ',
    markdown: `
# انسانیت کے لیے کامل نمونہ

صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ

---

### ایک حقیقی خاکہ

## نبی

# محمد ﷺ

(صلی اللہ علیہ وسلم)

---

**منہاج القرآن انٹرنیشنل**

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
  {
    slug: 'bismillah-page',
    name: 'بسم اللہ افتتاحی صفحہ',
    markdown: `
# بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ

اللہ کے نام سے شروع جو بہت مہربان نہایت رحم کرنے والا ہے

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
  {
    slug: 'traits-of-islam',
    name: 'اسلام کی خصوصیات کا صفحہ',
    markdown: `
# اسلام کی خصوصیات

محبت  
رحم  
ہمدردی  
مہربانی  
آزاد خیالی  
برداشت  
خیر خواہی  
معافی  
بردباری  
ایثار  
صدقہ  
امن  
اعتدال

**منہاج القرآن انٹرنیشنل (MQI)**

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
  {
    slug: 'table-of-contents',
    name: 'فہرستِ مواد',
    markdown: `
# فہرستِ مواد

**حصہ اول**  
کامل اور خوبصورت انسان کی شخصیت کی عمومی تفصیل: حضرت محمد ﷺ ............................................... ۱

**حصہ دوم**  
حضرت محمد ﷺ کی شخصیت کی حقیقی تصویر بیان کرنے والی ۶۳ خاص تفصیلات ............................................... ۴۱

۱. سب سے بلند نسب والے ................................................ ۴۳  
۲. حسن کا مجسمہ .............................................. ۴۴  
۳. بہترین ناموں اور القابات کے مالک ................... ۴۶  
۴. اعلیٰ ترین اخلاق والے ...................... ۴۸  
۵. سب سے زیادہ عاجزی کرنے والے ..................................... ۴۹  
۶. سب سے زیادہ سچے اور امانتدار ................................. ۵۰  
۷. سب سے زیادہ انصاف کرنے والے ..................................... ۵۱  
۸. سب سے زیادہ سخی .......................................... ۵۲  
۹. غیر معمولی نرمی والے ................................. ۵۳  
۱۰. نرم مزاجی کے مالک ............................... ۵۴  
۱۱. بات چیت میں سب سے زیادہ وقار والے ................ ۵۵  
۱۲. رحم کا سرچشمہ .................................... ۵۷  
۱۳. امن کے سفیر ..................................... ۵۸  
۱۴. کمزوروں اور محتاجوں کے مددگار .................... ۵۹  
۱۵. بیمار غلاموں کی دیکھ بھال کرنے والے ................. ۶۱  
۱۶. غلاموں کو آزاد کرنے والے ..................... ۶۲  
۱۷. مہاجرین کے محافظ ...................... ۶۳  
۱۸. جانوروں کے حقوق کے داعی ..................... ۶۴  
۱۹. نسل پرستی کے خلاف سب سے پہلے آواز اٹھانے والے ......... ۶۵  
۲۰. انسانیت کی قدر کرنے والے ...................... ۶۶  
۲۱. لوگوں کے لیے آسانی پیدا کرنے والے .................. ۶۷  
۲۲. اپنے اہل خانہ کے لیے سب سے مہربان .............. ۶۸  
۲۳. یتیموں اور بیواؤں کے نگہبان .................. ۶۹  
۲۴. عورتوں کے حقوق اور عزت کے وکیل ................ ۷۰  
۲۵. بچوں سے محبت کرنے والے ................... ۷۲  
۲۶. بہترین ہمسایہ ....................... ۷۴  
۲۷. لوگوں کی محنت کی قدر کرنے والے ...................... ۷۵  
۲۸. دوسروں کا سب سے زیادہ احترام کرنے والے ....... ۷۶  
۲۹. حقیقی انسان دوست اور فلاحی .................... ۷۷  
۳۰. بین المذاہب ہم آہنگی کے سفیر .................. ۷۸  
۳۱. معاشرتی اتحاد کے لیے کوشاں ..................... ۷۹  
۳۲. مختلف نسلوں کے لوگوں کی عزت کرنے والے ............ ۸۰  
۳۳. دشمنی اور نفرت مٹانے والے ....................... ۸۱  
۳۴. یہود دشمنی کے مخالف ....................................... ۸۳  
۳۵. نیکیوں کا اعتراف کرنے والے ......................... ۸۴  
۳۶. محبت کے داعی .................................. ۸۴  
۳۷. دیگر ادیان کا احترام کرنے والے ....................... ۸۵  
۳۸. غیر مسلموں کے محافظ ....................................... ۸۶  
۳۹. سابقہ انبیاء کی تعظیم کرنے والے .................. ۸۸  
۴۰. سب سے زیادہ معاف کرنے والے ..................... ۸۹  
۴۱. انتقام سے باز رہنے والے ................ ۹۰  
۴۲. معاملات میں نرمی کرنے والے ......... ۹۱  
۴۳. سب سے زیادہ صبر کرنے والے ... ۹۲  
۴۴. غصے پر قابو پانے والے ......... ۹۳  
۴۵. لعنت نہ کرنے والے ....... ۹۴  
۴۶. گنہگاروں پر رحم کرنے والے .... ۹۵  
۴۷. خوبصورت صحبت دینے والے ................ ۹۷  
۴۸. اپنے ماننے والوں سے سب سے زیادہ محبت کرنے والے ....... ۹۹  
۴۹. گرمجوشی سے سلام کرنے والے ....................... ۱۰۱  
۵۰. علم و حکمت کے عاشق .......................... ۱۰۲  
۵۱. ماحولیات کے وکیل ....................... ۱۰۳  
۵۲. صفائی کے استاد ............... ۱۰۴  
۵۳. پہلے آئین کے بانی ........... ۱۰۵  
۵۴. عظیم منتظم ...................... ۱۰۶  
۵۵. اعتدال کے داعی ....... ۱۰۷  
۵۶. نفس پر قابو سکھانے والے ....... ۱۰۸  
۵۷. نیکی میں تعاون کی ترغیب دینے والے ....... ۱۰۹  
۵۸. جنگ میں انصاف متعارف کروانے والے .. ۱۱۰  
۵۹. اسراف سے روکنے والے .. ۱۱۱  
۶۰. تنقید سننے میں سب سے بہتر .... ۱۱۲  
۶۱. وقت کا بہترین استعمال کرنے والے ........... ۱۱۳  
۶۲. آپ ﷺ کی تعلیمات ...... ۱۱۴  
۶۳. آپ ﷺ کے سنہری اصول ......... ۱۱۶  

**کتابیات** ............................................................. ۱۱۹

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
  {
    slug: 'part-1-opening',
    name: 'حصہ اول - افتتاحی صفحہ',
    markdown: `
# حصہ اول

### کامل اور خوبصورت انسان کی شخصیت کی عمومی تفصیل:  
حضرت محمد ﷺ

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
  {
    slug: 'part-1-chapter',
    name: 'حصہ اول - عمومی تفصیل',
    markdown: `
حضرت محمد ﷺ سب سے کامل انسان تھے۔ وہ عرب کے شہر مکہ میں پیدا ہوئے، پیر کی صبح سویرے، ربیع الاول کی بارہ تاریخ کو، ہاتھی والے سال میں (570 عیسوی)—ابراہا کی فوجوں کے کعبہ تباہ کرنے کے لیے آگے بڑھنے کے باون دن بعد۔

۱. **ان کی تخلیق:** اللہ تعالیٰ نے اپنی رحمت سے اپنے محبوب ﷺ کو تمام جہانوں کے لیے رحمت بنا کر بھیجا۔ حضرت محمد ﷺ وہ ہیں جن کی روح اللہ نے سب سے پہلے پیدا کی۔ یہ اللہ کے نور کی براہ راست برکت سے پیدا ہوئی، کائنات کی کسی چیز کے وجود میں آنے سے پہلے۔ روایت ہے کہ نبی ﷺ نے فرمایا: “جو چیز اللہ نے سب سے پہلے پیدا کی وہ تمہارے نبی کا نور ہے جو اس کے نور سے ہے۔”¹

۲. **نبی کا نور سے مراد ان کی روشن اور روشن کرنے والی روح ہے۔** اللہ کے نور سے پیدا ہونے کا مطلب یہ نہیں کہ یہ اللہ کے نور کا حصہ تھا یا اس سے نکلا۔ اللہ کی ذات پاک ہے۔ اللہ تعالیٰ خود نور نہیں بلکہ نور کا خالق ہے۔

۳. **اس کے نور سے پیدا کرنے کا مطلب یہ ہے کہ اللہ تعالیٰ نے حضرت محمد ﷺ کی روح کو کائنات کی پہلی مخلوق کے طور پر بغیر کسی واسطے کے پیدا کیا**، جیسا کہ تخلیق کے عمل میں ہوتا ہے، کیونکہ اس وقت کوئی مخلوق موجود نہیں تھی۔

۴. **“اس کے نور سے” کا اظہار ایک خاص الہی فعل کی تعظیم ہے**، اس مقدس کی انتہائی عزت والی اور غیر معمولی مرتبے کی نشاندہی کرنے کے لیے، جو اللہ کی خاص رحمت سے معجزانہ طور پر پیدا کیا گیا۔

¹ عبد الرزاق المصنف (الجزء المفقود)، ۱:۶۳ §۶۳۔ القسطلانی المواہب اللدنیہ، ۱:۷۱۔ الحلبی السیرہ الحلبیہ، ۱:۵۰۔

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
  {
    slug: 'part-2-opening',
    name: 'حصہ دوم - افتتاحی صفحہ',
    markdown: `
# حصہ دوم

### ۶۳ خاص تفصیلات  
جو حضرت محمد ﷺ کی شخصیت کی حقیقی تصویر بیان کرتی ہیں

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
  {
    slug: 'part-2-chapter-7',
    name: 'حصہ دوم - ۷۔ سب سے زیادہ انصاف کرنے والے',
    markdown: `
## ۷  
### سب سے زیادہ انصاف کرنے والے

حضرت محمد ﷺ نے لوگوں کے ساتھ انصاف کیا۔ انہوں نے مسلمانوں کو غیر مسلموں پر ظلم کرنے اور بچ نکلنے کی اجازت نہیں دی۔ آپ ﷺ نے فرمایا: “اگر کوئی مسلمان ایک عیسائی کو قتل کرے تو اسے (بدلے میں) قتل کیا جائے گا۔”¹

ایک اور موقع پر مکہ کی طاقتور قبیلوں کی ایک عورت چوری کے جرم میں پکڑی گئی۔ تو حضرت محمد ﷺ نے اسے سزا دینے کا فیصلہ کیا۔ تاہم کچھ صحابہ ﷺ نے آپ ﷺ سے التجا کی کہ اسے سزا نہ دیں کیونکہ وہ امیر گھرانے سے ہے۔ لیکن نبی ﷺ اٹھے اور صحابہ ﷺ سے خطاب کیا: “تم سے پہلے لوگ اس لیے تباہ ہوئے کہ جب ان کے معززین چوری کرتے تو چھوڑ دیتے، اور اگر کوئی غریب چوری کرتا تو اسے سزا دیتے۔ اللہ کی قسم! اگر محمد کی بیٹی فاطمہ نے بھی چوری کی تو میں اس کا بھی ہاتھ کاٹ دوں گا (یعنی اسے بھی جرم کی سزا دوں گا)۔”²

اس واقعہ سے قانون کے سامنے برابری کا اصول نظر آتا ہے کہ کوئی قانون سے بالاتر نہیں۔ نبی ﷺ کا انصاف اتنا عظیم تھا کہ وہ معززین کو ان کے جرائم سے بچنے نہیں دیتے اور صرف عام لوگوں کو سزا دیتے۔ آپ ﷺ نے اعلان کیا کہ آپ ﷺ کا اپنا خاندان بھی قانون کی پابندی کرے اور اس کی خلاف ورزی نہ کرے۔

¹ الشافعی المسند، ص ۳۴۳۔ البیہقی السنن الکبریٰ، ۸:۳۰ §۱۵۶۹۶۔

² البخاری الصحیح، ۳:۱۳۶۶ §۳۵۲۶۔ مسلم الصحیح، ۳:۱۳۱۵ §۱۶۸۸۔

*(صفحہ ختم – نیا صفحہ شروع)*
`,
  },
];